import { TextVariantType } from '../variants';
import { getMainSectionStyles } from './variantStyles/mainSection';
import { getRegularStyles } from './variantStyles/regular';
import { getSecondaryStyles } from './variantStyles/secondary';
import { BadgeNotificationSize } from './variants';
export const getBadgeNotificationStyles = (FOUNDATIONS, FONT) => {
    return {
        [BadgeNotificationSize.LARGE]: {
            icon: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_350,
            },
            label: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
            },
            customDotTranslate: 'translate(0px, 0px)',
        },
        [BadgeNotificationSize.SMALL]: {
            icon: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            label: {
                font_variant: TextVariantType.FONT_PARAGRAPH_650,
            },
            customDotTranslate: 'translate(0px, 0px)',
        },
        ...getRegularStyles(FOUNDATIONS, FONT),
        ...getSecondaryStyles(FOUNDATIONS, FONT),
        ...getMainSectionStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map